<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.SECTION.modal-content
        +e.P.text_paragraph В обычном режиме, максимальная скорость скачивания ограничена #[b= '56 кб/с.']
        +e.P.text_paragraph
            | Вы можете оформить подписку в
            | #[a.link(href="http://store.rsl.ru/") интернет-магазине РГБ],
            | которая позволит вам скачивать документы через выделенный канал #[b без ограничения скорости.]
        +e.UL.list._vertical
            +e.LI.item
                +e.BUTTON.btn.btn._size_md._theme_fill._full(
                    href="http://store.rsl.ru/profile/download_document?docId=01008709356"
                    target="_blank"
                ) {{ $t('DOWNLOAD_WITHOUT_SPEED_LIMIT') }}
            +e.LI.item
                +e.BUTTON.btn.btn._size_md._theme_transp._full(
                    v-bind:href="`${url}/loader/view/${$route.params.id}?get=pdf`"
                    target="_blank"
                ) {{ $t('DOWNLOAD_NORMALLY') }}
</template>

<script>
import setApiUrl from '@/helpers/api/index';

export default {
    data() {
        return {
            url: setApiUrl()
        };
    }
};
</script>
